var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 2.054L1.179.875l3.823 3.891L8.822.875 10 2.055l-4.998 5.07L0 2.055z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }